import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTimes } from '@fortawesome/free-solid-svg-icons';

import { logout } from '../../services/sessionService';
import './styles.css';

/**
 * Faixa da visualizacao do suporte ("ver como cliente"): deixa claro que a sessao
 * e de outra pessoa e so leitura. Sair so apaga esta sessao; o cliente continua logado.
 */
export default function ViewAsBanner({ name }) {
  const handleExit = async () => {
    await logout('client');
    window.location.href = '/admin/users';
  };

  return (
    <div className='va-banner' role='status'>
      <FontAwesomeIcon icon={faEye} aria-hidden='true' />
      <span className='va-text'>
        Você está vendo como <strong>{name || 'o cliente'}</strong>
        <span className='va-hint'> · somente leitura · encerra sozinha em 30 min</span>
      </span>
      <button type='button' className='va-exit' onClick={handleExit}>
        <FontAwesomeIcon icon={faTimes} aria-hidden='true' />
        Sair da visualização
      </button>
    </div>
  );
}
